import { Component, OnInit, Injector, ViewChild, Injectable, ElementRef } from '@angular/core';
import { AlertService } from 'src/app/Common/alert.service';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatPaginator as MatPaginator, PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
// import { MatTable as MatTable, MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { DataService } from 'src/app/Common/data.service';
import { CommonService } from 'src/app/shared/common.service';
import { count } from 'rxjs/operators';
//import * as internal from 'assert';
import { add } from 'ngx-bootstrap/chronos';
import { Global } from 'src/app/Global';
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';

@Component({
  selector: 'app-assigment-group',
  templateUrl: './assigment-group.component.html',
  styleUrls: ['./assigment-group.component.scss'],
  providers: [DataService]
})
export class AssigmentGroupComponent implements OnInit {
  AssigmentForm: UntypedFormGroup;
  //AssigmentDataSource:any[];
  requesterList: any;
  filterList: any;
  viewdata: any;
  groupList: any;
  locationList: any;
  moderatorList: any;
  public show: boolean = false;
  displayedColumns2 = ['GroupName', 'Moderator', 'location', 'EmployeeGPN', 'EmployeeName', 'Status', 'Update'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  AssigmentDataSourceView: any[];
  pageEvent: PageEvent;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  employeeList: any;
  Ispanelshow: any;
  IsAddpanelshow: any;
  IsReplacepanelshow: any;
  IsLoadingResults = false;
  IsOfficeLocLoading: boolean = false;
  OfficeLocList: any[] = [];
  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute,
    injector: Injector, private _dialog: MatDialog,
    private status: HTTPStatus, public _dataservice: DataService, public _commonService: CommonService, public _global: Global) { }

  ngOnInit() {

    //debugger;
    this.paginator.showFirstLastButtons = true;
    this.paginator.pageSize = this._global.RecordSize;
    this.AssigmentForm = this._fb.group({
      Group: ['', Validators.required],
      Moderator: ['', Validators.required],
      Location: ['', Validators.required],
      EmpName: ['', Validators.required],
      // Assigment: new MatTableDataSource(ELEMENT_DATA),
      AddGroupName: ['', Validators.required],
      Id: [''],
      GroupId: [''],
      ModeratorId: [''],
      LocationId: [''],
      EmployeeGPN: [''],
      RequesterName: [''],
      RequesterGPN: [''],
      Requesterphone: [''],
      PageNumber: (this._global.pageIndex),
      PageSize: (this._global.RecordSize),
      IsActive: [''],
      //added by anmol kaur
      Employee: [""],
      GroupSearch: [""],
      LocationSearch: [""],
      EmpGPN: [""],
      OldEmpName: [""],
      ToEmpName: [""],
      ToEmpGPN: [""],
      GroupReplace: [""],
      LocationReplace: [""],
    });
    this.BindGroupList();
    this.BindModeratorList();
    this.BindLocationList();
    this.SearchRecord();
  }

  SearchRecord() {
    this._global.pageIndex = 0;
    this._global.length = 0;
    this._global.totalPage = 0;
    this._global.RecordSize = 10;
    this.ViewDataList();
  }

  ViewDataList() {
    this.AssigmentForm.controls.PageNumber.setValue(this._global.pageIndex + 1);
    this.AssigmentForm.controls.PageSize.setValue(this._global.RecordSize);
    //added by anmol kaur for search param
    this.AssigmentForm.patchValue({
      GroupId: this.AssigmentForm.controls.GroupSearch.value.GroupId,
      EmpGPN: this.AssigmentForm.controls.Employee.value.EmployeeGPN,
      LocationId: this.AssigmentForm.controls.LocationSearch.value.locationid,
    });

    this._dataservice.PostData('Category/GetAssigmentGroupList/', this.AssigmentForm.value).subscribe(result => {
      this.viewdata = result;

      if (this.viewdata != null && this.viewdata.length > 0) {
        this.AssigmentDataSourceView = this.viewdata;


        this._global.length = this.viewdata[0].totalrecordcount;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);

      } else {
        this.AssigmentDataSourceView = this.viewdata;
        this._global.length = 0;
        this.paginator.pageSize = this._global.RecordSize;
        this._global.pageIndex = 0;
        this._global.totalPage = 0;
      }
    });
  }


  onPaginateChange1(event) {
    this._global.pageIndex = event.pageIndex;
    this._global.RecordSize = event.pageSize;
    this.ViewDataList();
  }

  SearchActiveEmployee = (event) => {

    this._commonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      this.requesterList = this.filterDataList(event.query, result);

    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }

  BindGroupList() {

    this.IsLoadingResults = true;
    this._dataservice.GetData('Category/GetGroup/').subscribe(result => {

      this.groupList = result;
      this.IsLoadingResults = false;
    });
  }

  BindModeratorList() {

    this._dataservice.GetData('Category/Getmoderator/').subscribe(result => {

      this.moderatorList = result;
    });
  }

  DisableLocation() {
    this.AssigmentForm.patchValue({
      ModeratorId: this.AssigmentForm.controls.Moderator.value.KeywordValue,
    });
    if (this.AssigmentForm.controls.ModeratorId.value == 1) {
      this.AssigmentForm.patchValue({
        Location: this.BindSpecializationLocation('All'),
      })
      this.AssigmentForm.controls.Location.disable();
    }
    else {
      this.AssigmentForm.patchValue({
        Location: this.BindSpecializationLocation('--Select--'),
      })
      this.AssigmentForm.controls.Location.enable();
    }
  }

  ChangeModerator() {
    this.AssigmentForm.patchValue({
      LocationId: this.AssigmentForm.controls.Location.value.locationid,
    });
    if (this.AssigmentForm.controls.LocationId.value == -1) {
      this.AssigmentForm.patchValue({
        Moderator: this.BindSpecializationModerator('Yes'),
      })
    }
    else {
      this.AssigmentForm.patchValue({
        Moderator: this.BindSpecializationModerator('No'),
      })

    }
  }

  BindSpecializationModerator(sf) {
    let p = this.moderatorList.filter(x => x.KeywordName == sf);
    return p[0];
  }

  BindSpecializationLocation(sf) {

    let p = this.locationList.filter(x => x.location == sf);
    return p[0];
  }

  BindLocationList() {

    this._dataservice.GetData('Category/GetLocation/').subscribe(result => {

      this.locationList = result;
    });
  }


  rowdeletedata(element) {
    // this.AssigmentDataSource.data.splice(element,1);
    //   this.AssigmentDataSource = new MatTableDataSource<any>(this.AssigmentDataSource.data);

    if (confirm('Are you sure to want delete this record?')) {
      this.AssigmentForm.patchValue({
        // Assigment:this.AssigmentForm.controls.Assigment.value.data,
        GroupId: 0,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddData/', this.AssigmentForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.ClearData();
          this.ViewDataList();
        }

      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }

  statusupdatedata(element) {
    // this.AssigmentDataSource.data.splice(element,1);
    //   this.AssigmentDataSource = new MatTableDataSource<any>(this.AssigmentDataSource.data);

    if (confirm('Are you sure to want update status this record?')) {
      this.AssigmentForm.patchValue({
        // Assigment:this.AssigmentForm.controls.Assigment.value.data,
        GroupId: 1,
        Id: element,
      });
      this.status.setHttpStatus(true);
      this._dataservice.PostData('Category/AddData/', this.AssigmentForm.value).subscribe(result => {
        alert(result[0].MSG);
        if (result[0].STATUS == 0) {
          this.ClearData();
          this.ViewDataList();
        }

      }
        , (error) => {
          this.status.setHttpStatus(false);
          this.error.handleError(error);
        },
        () => { this.status.setHttpStatus(false); });
    }
  }

  rowclickdata(row: any) {

    var dataitem;
    dataitem = this.AssigmentDataSourceView.filter(x => x.Id == row);
    this.AssigmentForm.patchValue({

      EmpName: dataitem[0]['EmployeeName'],
      Id: row,
      Group: this.BindSpecialization(dataitem[0]['GroupName']),
      IsActive: dataitem[0]['IsActive'],
    });
    this.requesterList = {
      EmployeeGPN: dataitem[0]['EmpGPN'], EmployeeName: dataitem[0]['EmpName'] + '(' + dataitem[0]['EmpEmail'] + ')'
    };
    this.AssigmentForm.controls.EmpName.setValue(this.requesterList);
    this.AssigmentForm.controls.RequesterGPN.setValue(dataitem[0]['EmpGPN']);
  }

  BindSpecialization(sf) {

    let p = this.groupList.filter(x => x.GroupName == sf);
    return p[0];
  }

  // submitdata()
  // {
  //  
  //   this.AssigmentForm.patchValue({
  //     Assigment:this.AssigmentForm.controls.Assigment.value.data,
  //    });
  //   this._dataservice.PostData('Category/SaveAssigment/',this.AssigmentForm.value).subscribe(result =>{
  //   this.viewdata = result;
  //   this.Relod();
  // })
  // }

  Adddata() {
    this.GetFormControls('AddGroupName').clearValidators();
    this.GetFormControls('AddGroupName').updateValueAndValidity();
    this.GetFormControls('Group').setValidators([Validators.required]);
    this.GetFormControls('Group').updateValueAndValidity();
    this.GetFormControls('Moderator').setValidators([Validators.required]);
    this.GetFormControls('Moderator').updateValueAndValidity();
    this.GetFormControls('Location').setValidators([Validators.required]);
    this.GetFormControls('Location').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    if (!this.AssigmentForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.GetFormControls('AddGroupName').setValidators([Validators.required]);
    this.GetFormControls('AddGroupName').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this.AssigmentForm.patchValue({
      // Assigment:this.AssigmentForm.controls.Assigment.value.data,
      GroupId: this.AssigmentForm.controls.Group.value.GroupId,
      EmployeeGPN: this.AssigmentForm.controls.EmpName.value.EmployeeGPN,
      ModeratorId: this.AssigmentForm.controls.Moderator.value.KeywordValue,
      LocationId: this.AssigmentForm.controls.Location.value.locationid,
    });
    this._dataservice.PostData('Category/AddData/', this.AssigmentForm.value).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.ClearData();
        this.ViewDataList();
        this.GetFormControls('Group').clearValidators();
        this.GetFormControls('Group').updateValueAndValidity();
        this.GetFormControls('Moderator').clearValidators();
        this.GetFormControls('Moderator').updateValueAndValidity();
        this.GetFormControls('Location').clearValidators();
        this.GetFormControls('Location').updateValueAndValidity();
        this.GetFormControls('EmpName').clearValidators();
        this.GetFormControls('EmpName').updateValueAndValidity();
      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => {
        this.status.setHttpStatus(false);
      });
  }

  ClearData() {
    this.AssigmentForm.controls.Group.setValue('');
    this.AssigmentForm.controls.Moderator.setValue('');
    this.AssigmentForm.controls.Location.setValue('');
    this.AssigmentForm.controls.EmpName.setValue('');
    this.AssigmentForm.patchValue({
      Id: 0
    });
  }



  Relod() {
    window.location.reload();
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.AssigmentForm.controls).forEach(field => {
      const control = this.AssigmentForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetFormControls(controlName) {
    return this.AssigmentForm.controls[controlName];
  }

  addgroup() {
    this.GetFormControls('Group').clearValidators();
    this.GetFormControls('Group').updateValueAndValidity();
    this.GetFormControls('Moderator').clearValidators();
    this.GetFormControls('Moderator').updateValueAndValidity();
    this.GetFormControls('Location').clearValidators();
    this.GetFormControls('Location').updateValueAndValidity();
    this.GetFormControls('EmpName').clearValidators();
    this.GetFormControls('EmpName').updateValueAndValidity();
    this.GetFormControls('AddGroupName').setValidators([Validators.required]);
    this.GetFormControls('AddGroupName').updateValueAndValidity();

    if (!this.AssigmentForm.valid) {
      alert('Please fill Group Name');
      this.showErrorsOnInvalidForm();

      return false;
    }
    this.GetFormControls('Group').setValidators([Validators.required]);
    this.GetFormControls('Group').updateValueAndValidity();
    this.GetFormControls('Moderator').setValidators([Validators.required]);
    this.GetFormControls('Moderator').updateValueAndValidity();
    this.GetFormControls('Location').setValidators([Validators.required]);
    this.GetFormControls('Location').updateValueAndValidity();
    this.GetFormControls('EmpName').setValidators([Validators.required]);
    this.GetFormControls('EmpName').updateValueAndValidity();

    this.status.setHttpStatus(true);
    this._dataservice.PostData('Category/SaveGroup/', { 'AddGroupName': this.AssigmentForm.controls.AddGroupName.value }).subscribe(result => {
      alert(result[0].MSG);
      if (result[0].STATUS == 0) {
        this.AssigmentForm.controls.AddGroupName.setValue('');
        this.toggle();
        this.BindGroupList();
        this.GetFormControls('AddGroupName').clearValidators();
        this.GetFormControls('AddGroupName').updateValueAndValidity();

      }

    }
      , (error) => {
        this.status.setHttpStatus(false);
        this.error.handleError(error);
      },
      () => { this.status.setHttpStatus(false); });
  }


  SetEmployeeDetails(event) {

    //ELEMENT_DATA.push({EmployeeGPN: event.EmployeeGPN, EmployeeName: event.EmpName, GroupName: this.AssigmentForm.controls.Group.value.GroupName, GroupId:this.AssigmentForm.controls.Group.value.GroupId})
    //this.AssigmentDataSource = new MatTableDataSource(ELEMENT_DATA);
    RequesterName: event.EmpName;
    RequesterGPN: event.EmployeeGPN;

  }



  clearAutoComplete(controlName) {

    this.AssigmentForm.controls.RequesterGPN.reset();
    this.AssigmentForm.controls.RequesterName.reset();
  }

  toggle() {
    this.show = !this.show;
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Assigment_Group.xlsx');

  }

  Export() {
    this.status.setHttpStatus(true);
    this._commonService.ExportToExcelAssignmentGroup(this.AssigmentForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'Assigment_Group.xls');
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  clearAutoCompleteSearch(ControlName) {
    if (ControlName == "Employee") {
      this.AssigmentForm.controls.Employee.reset();
    } else if (ControlName == "GroupSearch") {
      this.AssigmentForm.controls.GroupSearch.reset();
    }
  }
//added by anmol kaur
  ResetData() {
    this.AssigmentForm.reset({
      Employee: "",
      LocationSearch: "",
      GroupSearch: "",
    });
    this.GetResult();
  }
//added by anmol kaur
  Exit() {
    if (this.AssigmentForm.valid) {
      if (confirm("Are you sure you want to exit without saving changes?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    } else {
      if (confirm("Are you sure to exit?")) {
        //this.router.navigate(['dashboard']);
        window.history.back();
      }
    }
  }
//added by anmol kaur
  GetResult() {
    this.SearchRecord();
  }
//added by anmol kaur
  showhide() {
    this.Ispanelshow = !this.Ispanelshow;
  }
//added by anmol kaur
  showhideAdd() {
    this.IsAddpanelshow = !this.IsAddpanelshow;
  }

  showhideReplace() {
    this.IsReplacepanelshow = !this.IsReplacepanelshow;
  }


}

// export interface Element {
//   EmployeeGPN: string;
//   EmployeeName: string;
//   GroupName: string;
//   GroupId:string;
// }

// const ELEMENT_DATA: Element[] = [
//   {EmployeeGPN: '1', EmployeeName: 'Hydrogen', GroupName: 'hello'},
//   {EmployeeGPN: '2', EmployeeName: 'Helium', GroupName: 'hello1'}
// ];
